import { Mapper } from 'src/base/mapper'
import { ClientTypeEntity } from 'src/data/entities/client.entity'
import { ClientTypeModel } from 'src/domain/models/client.model'

export class ClientMapper extends Mapper<ClientTypeEntity, ClientTypeModel> {
	mapFrom(param: ClientTypeEntity): ClientTypeModel {
		return this.resultData(param)
	}

	mapTo(param: ClientTypeModel): ClientTypeEntity {
		return this.resultData(param)
	}

	resultData(param: ClientTypeEntity | ClientTypeModel) {
		return {
			tenantId: param.tenantId,
			pictureUrl: param.pictureUrl,
			companyPicture: param.companyPicture,
			clientId: param.clientId,
			accountType: param.accountType,
			industryId: param.industryId,
			fullName: param.fullName,
			fristName: param.fristName,
			lastName: param.lastName,
			taxId: param.taxId,
			paymentTerm: param.paymentTerm,
			companyName: param.companyName,
			email: param.email,
			phone: param.phone,
			mobile: param.mobile,
			isActive: param.isActive,
			isCreated: param.isCreated,
			isVenioCreated: param.isVenioCreated,
			isStorageEncrypionKeyExists: param.isStorageEncrypionKeyExists,
			address: param.address,
			contacts: param.contacts,
			password: param.password,
			confirmPassword: param.confirmPassword,
			custAccount: param.custAccount,
			productId: param.productId,
			roles: param.roles,
			additionalSeats: param.additionalSeats,
			isThaiCompany: param.isThaiCompany,
			isSendToD365: param.isSendToD365,
			emailTaxInvoice: param.emailTaxInvoice,
			customerType: param.customerType,
			numberOfEmployees: param.numberOfEmployees,
			couponCode: param.couponCode,
			isSendMail: param.isSendMail,
			isOwner: param.isOwner,
			isSendToVenio: param.isSendToVenio,
			deliveryReason: param.deliveryReason,
			inclTax: param.inclTax,
			uniqueName: param.uniqueName,
			dateCreated: param.dateCreated,
			createdByUserId: param.createdByUserId,
			clientAddressId: param.clientAddressId,
			isSplitInvoice: param.isSplitInvoice,
			referralClientId: param.referralClientId,
			dateFirstPaided: param.dateFirstPaided,
			isTest: param.isTest,
			isExcludeVat: param.isExcludeVat,
		}
	}
}
